import React from 'react'
import Helmet from 'react-helmet'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import useSiteMetadata from './SiteMetadata'
import './all.css'

const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata()
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="p:domain_verify" content="965ddc9eb89f7f8a639f324a34cc92ec" />
        <meta name="google-site-verification" content="put_xvyNicV4zrPugpWl4POFOA0gv6BONZueJSAXz1c" />
        <link rel="stylesheet" href="https://use.typekit.net/cjz6mpl.css" />

        <link
          rel="icon"
          type="image/png"
          href="/img/favicon.png"
          sizes="32x32"
        />

        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
        <meta property="og:url" content="/" />
        <meta property="og:image" content="logo.png" />
      </Helmet>
      <Navbar />
      {children}
      <Footer />
    </div>
  )
}

export default TemplateWrapper
